angular
  .module 'memberPortal'
  .controller 'EventsCtrl', (
    $scope,
    $state,
    $stateParams,
    $http,
    $filter,
    Restangular,
    CwStorage,
    DataService,
    locations,
    instructors,
    styles,
    eventTypes
  ) ->
    $scope.locations = locations
    $scope.instructors = instructors
    $scope.styles = styles
    $scope.eventTypes = eventTypes
    $scope.data = DataService
    $scope.isMa = DataService.martial_arts_gym
    $scope.isShowStyleFilter = DataService.show_style_filter
    $scope.isShowInstructorFilter = DataService.show_instructor_filter
    $scope.isShowEventTypeFilter = DataService.show_event_type_filter
    domain = $scope.data.domain
    $scope.hash = $stateParams.m
    $scope.group_events_by = DataService.group_events_by
    $scope.fromDate = moment(new Date()).format('YYYY-MM-DD')
    $scope.currentDate = moment(new Date()).format('YYYY/MM/DD')
    savedDate =
      moment(CwStorage.getItem('memberPortalEventsDate'), moment.ISO_8601)
    $scope.date =
      if $stateParams.origin isnt 'sidebar' and savedDate.isValid()
        savedDate
      else
        CwStorage.setItem('memberPortalEventsDate', undefined)
        moment()

    $scope.getDropdownValue = (value, items) ->
      option = _.find items, (item) ->
        item.id is value
      option?.name

    getValueId = (key, collection) ->
      id = parseInt(CwStorage.getItem('memberPortalEventsLocation'))
      if $scope.getDropdownValue(id, collection) then id else undefined

    $scope.locationId = getValueId('memberPortalEventsLocation', locations)
    $scope.instructorId = getValueId('memberPortalEventsInstructor', instructors)
    $scope.styleId = getValueId('memberPortalEventsStyle', styles)
    $scope.eventTypeId = getValueId('memberPortalEventsEventType', eventTypes)

    $scope.eventDetails = (event) ->
      [event.classroom_name, event.instructor_names].join(', ')

    $scope.switchWeek = (value) ->
      $scope.date = $scope.date.add(value, 'weeks')
      CwStorage.setItem('memberPortalEventsDate', $scope.date.toISOString())
      $scope.getEvents()

    parseTime = (time, event) ->
      if event.event_tz_type is 'browser'
        moment.utc(time, 'YYYY/MM/DD HH:mm').local()
      else
        moment(time, 'YYYY/MM/DD HH:mm')

    $scope.startTime = (event) ->
      parseTime(event.start_at, event).format('h:mma')

    $scope.selectLocation = (locationId) ->
      $scope.locationId = locationId
      CwStorage.setItem('memberPortalEventsLocation', locationId)
      $scope.getEvents()

    $scope.selectInstructor = (instructorId) ->
      $scope.instructorId = instructorId
      CwStorage.setItem('memberPortalEventsInstructor', instructorId)
      $scope.getEvents()

    $scope.selectStyle = (styleId) ->
      $scope.styleId = styleId
      CwStorage.setItem('memberPortalEventsStyle', styleId)
      $scope.getEvents()

    $scope.selectEventType = (eventTypeId) ->
      $scope.eventTypeId = eventTypeId
      CwStorage.setItem('memberPortalEventsEventType', eventTypeId)
      $scope.getEvents()

    getEventsByDay = (events, start, end) ->
      start = moment() if start.isSame(moment(), 'week')
      days = {}
      while start.isSameOrBefore(end, 'day')
        days[start.format('YYYY/MM/DD')] = []
        start.add(1, 'days')
      groupedEvents = _.groupBy events, (event) ->
        parseTime(event.start_at, event).format('YYYY/MM/DD')
      angular.extend days, groupedEvents

    getEventsForCurrentDay = (events) ->
      days = {}
      groupedEvents = _.groupBy events, (event) ->
        parseTime(event.start_at, event).format('YYYY/MM/DD')
      if !($scope.currentDate of groupedEvents)
        days[$scope.currentDate] = []
      angular.extend days, groupedEvents

    $scope.switchDay = (date) ->
      $scope.date = moment(new Date(date))
      $scope.getEvents()
      $scope.currentDate = moment(new Date(date)).format('YYYY/MM/DD')

    $scope.showEventsDependingGroupBy = (day) ->
      $scope.group_events_by is 'day' && day is $scope.currentDate || $scope.group_events_by is 'week'

    $scope.displayStatus = (event) ->
      switch
        when event.member_portal_booking_status
          event.member_portal_booking_status
        when event.invite_to_waitlist
          'Full (Waitlist Available)'
        when event.on_waitlist
          order = $filter('ordinalize')(event.waitlist_position)
          "(#{order} on waitlist)"

    getUTCTimestamp = (date) ->
      dateString = date.format('YYYY-MM-DDTHH:mm:ss')
      moment.utc(dateString).format('X')

    $scope.getEvents = ->
      $scope.isLoading = true
      $scope.eventsByDay = {}
      start = $scope.date.clone().startOf('week')
      end = $scope.date.clone().endOf('week')
      $scope.title =
        if start.format('YYYY') is end.format('YYYY')
          "#{start.format('MMM D')} - #{end.format('MMM D, YYYY')}"
        else
          "#{start.format('MMM D, YYYY')} - #{end.format('MMM D, YYYY')}"
      params =
        count: 500
        location_id: $scope.locationId
        instructor_id: $scope.instructorId
        event_type_id: $scope.eventTypeId
        style_id: $scope.styleId
        start: getUTCTimestamp(start)
        end: getUTCTimestamp(end)
        browser_tz: moment().format('Z')
      Restangular.all('events').getList(params).then (events) ->
        $scope.isLoading = false
        $scope.eventsByDay = switch $scope.group_events_by
          when 'week'
            getEventsByDay(events.plain(), start.clone(), end)
          when 'day'
            getEventsForCurrentDay(events.plain())

    $scope.getEvents()
